import { render } from "./SponsorDonateListForm.vue?vue&type=template&id=3d745411"
import script from "./SponsorDonateListForm.vue?vue&type=script&lang=js"
export * from "./SponsorDonateListForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__